import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

/**
 * GRIEVANCE API CONFIGURATION
 * Keys match the backend routes exposed by /api/v1/grievance
 * Backend: pms-api/src/grievance/grievance.controller.ts
 */
export const grievanceConfig = {
  /* ------------------------------- GET ----------------------------------- */
  getGrievances: {
    key: "getGrievances",
    url: "/api/v1/grievance/requests",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getGrievanceById: {
    key: "getGrievanceById",
    url: (data) => `/api/v1/grievance/requests/${data.grievanceId || data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.SHORT,
    },
  },

  getGrievanceLogs: {
    key: "getGrievanceLogs",
    url: (data) =>
      `/api/v1/grievance/requests/${data.grievanceId || data.id}/logs`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.SHORT,
    },
  },

  getGrievanceStats: {
    key: "getGrievanceStats",
    url: "/api/v1/grievance/stats",
    method: "GET",
    options: {
      ...QUERY_PRESETS.SHORT,
    },
  },

  /* ------------------------------- POST ---------------------------------- */
  createGrievance: {
    key: "createGrievance",
    url: "/api/v1/grievance/requests",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getGrievances", "getGrievanceStats"],
    },
  },

  createLinkedMaintenanceRequest: {
    key: "createLinkedMaintenanceRequest",
    url: (data) =>
      `/api/v1/grievance/requests/${data.grievanceId || data.id}/maintenance-request`,
    method: "POST",
    options: {
      retry: 1,
      invalidateKeys: [
        "getGrievances",
        "getGrievanceById",
        "getGrievanceLogs",
        "getMaintenanceRequests",
        "getMaintenanceStats",
        "getRooms",
        "getRoomTypes",
      ],
    },
  },

  markGrievanceRoomChanged: {
    key: "markGrievanceRoomChanged",
    url: (data) =>
      `/api/v1/grievance/requests/${data.grievanceId || data.id}/room-changed`,
    method: "PATCH",
    options: {
      retry: 1,
      invalidateKeys: ["getGrievanceById", "getGrievances"],
    },
  },

  /* ------------------------------- PUT/PATCH ----------------------------- */
  updateGrievance: {
    key: "updateGrievance",
    url: (data) =>
      `/api/v1/grievance/requests/${data.grievanceId || data.id}`,
    method: "PUT",
    options: {
      retry: 2,
      invalidateKeys: [
        "getGrievances",
        "getGrievanceById",
        "getGrievanceLogs",
      ],
    },
  },

  updateGrievanceStatus: {
    key: "updateGrievanceStatus",
    url: (data) =>
      `/api/v1/grievance/requests/${data.grievanceId || data.id}/status`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: [
        "getGrievances",
        "getGrievanceById",
        "getGrievanceLogs",
        "getGrievanceStats",
      ],
    },
  },
};
